
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/vouchers/explain-vouchers",
      function () {
        return require("private-next-pages/[lang]/vouchers/explain-vouchers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/vouchers/explain-vouchers"])
      });
    }
  